"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createSocialShareLinks = require("./../../utils/createSocialShareLinks");
var _helpers = require("./../../utils/helpers");
var _SocialShareBlockModule = _interopRequireDefault(require("./../../scss/blocks/SocialShareBlock.module.scss"));
function SocialShareButton({
  children,
  network,
  url,
  text,
  longtext
}) {
  const shareContent = e => {
    e.preventDefault();
    const networkLink = (0, _createSocialShareLinks.getSocialNetworkLink)({
      network,
      url,
      text,
      longtext
    });
    (0, _helpers.windowOpen)(networkLink);
  };
  return /*#__PURE__*/_react.default.createElement("button", {
    className: (0, _helpers.classes)(['social-share__button', _SocialShareBlockModule.default['social-share__button']]),
    "aria-label": `Share on ${network}`,
    onClick: e => shareContent(e),
    title: `Share on ${network}`
  }, children);
}
var _default = exports.default = SocialShareButton;